import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  // Obtenir tous les paramètres
  findAll(): Observable<any> {
    return this.http.get(`${this.baseUrl}/settings`, {
      headers: this.getHeaders(),
    });
  }
}
